var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 31.8333H4.91663C2.29328 31.8333 0.166626 29.7067 0.166626 27.0833V1.74996C0.166626 0.875516 0.875516 0.166626 1.74996 0.166626H23.9166C24.7911 0.166626 25.5 0.875516 25.5 1.74996V20.75H31.8333V27.0833C31.8333 29.7067 29.7067 31.8333 27.0833 31.8333ZM25.5 23.9166V27.0833C25.5 27.9578 26.2088 28.6666 27.0833 28.6666C27.9578 28.6666 28.6666 27.9578 28.6666 27.0833V23.9166H25.5ZM22.3333 28.6666V3.33329H3.33329V27.0833C3.33329 27.9578 4.04218 28.6666 4.91663 28.6666H22.3333ZM6.49996 8.08329H19.1666V11.25H6.49996V8.08329ZM6.49996 14.4166H19.1666V17.5833H6.49996V14.4166ZM6.49996 20.75H14.4166V23.9166H6.49996V20.75Z",
    fill: "#0AC79A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar1);
export default __webpack_public_path__ + "static/media/solar1.af2d740df1f83f893892e1879d189cbf.svg";
export { ForwardRef as ReactComponent };